module.exports = "/assets/data/6f46e92ff28ac6d522a0ef132ac994cd-BD23.data.json";